export default __webpack_public_path__ + "locales/ru/SingleSignOn.json?hash=5e2ab1b735031bb8750abd8cb27d1fb2";